<template>
  <div class="input-group mb-3 home-subscribe home-subscribe-ib">
    <b-input-group class="mt-3">
    <b-button v-if="!$auth.isAuthenticated" class="btn get-started-btn" to="/register" variant="primary">{{ $t('getstarted.getStarted') }}</b-button>
    <b-button v-if="$auth.isAuthenticated" class="btn get-started-btn" to="/invest" variant="primary">{{ $t('getstarted.startInvesting') }}</b-button>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: 'GetStarted',
  data()
  {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.home-subscribe-ib {
  display: inline-block;

  .get-started-btn {
    width: 100% !important;
    transition: color 0.2s ease-in-out, background-color 0.3s ease-in-out, border-color 0.3s ease-in-out, box-shadow 0.2s ease-in-out;
    &:hover{
      background: #3A4045;
      border-color: #3A4045 !important;
    }
  }
}

.home-subscribe {
  max-width: 420px;
  text-align: center;
  margin: 24px auto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  display: inline-block;

  .form-control {
    background: #FFFFFF;
    border: 2px solid #DFE1E6;
    box-sizing: border-box;
    border-radius: 24px;
    height: 48px;
  }

  .btn {
    background: #30A7FE;
    border-radius: 24px;
    color: #FFFFFF;
  }

  .get-started-btn {
    width: 67%;
    padding: 10px 12px;
  }
}

@media only screen and (max-width: 585px) {
  form, .mt-3, .get-started-btn {
    width: 100% !important;
    margin-bottom: 5px;
  }
}
</style>
